import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async list(options?: ApiSchemas['ListMedicalDocumentTemplateDto']) {
    return wrapEndpoint(() =>
      client.GET('/medical-document-template', {
        params: {
          query: options,
        },
      }),
    )
  },

  async create(template: ApiSchemas['CreateMedicalDocumentTemplateDto']) {
    return wrapEndpoint(() =>
      client.POST('/medical-document-template', {
        body: template,
        bodySerializer(body) {
          const formData = new FormData()
          formData.append('type', body.type)
          formData.append('physicianId', body.physicianId.toString())
          formData.append('name', body.name)
          if (body.clinicLogo) {
            formData.append('clinicLogo', body.clinicLogo)
          }
          formData.append('include', JSON.stringify(body.include))
          if (body.choices) {
            formData.append('choices', JSON.stringify(body.choices))
          }

          return formData
        },
      }),
    )
  },

  async update(id: number, template: ApiSchemas['UpdateMedicalDocumentTemplateDto']) {
    return wrapEndpoint(() =>
      client.PUT('/medical-document-template/{id}', {
        params: {
          path: {
            id,
          },
        },
        body: template,
        bodySerializer(body) {
          const formData = new FormData()
          if (body.type) {
            formData.append('type', body.type)
          }
          if (body.name) {
            formData.append('name', body.name)
          }
          if (body.clinicLogo) {
            formData.append('clinicLogo', body.clinicLogo)
          }
          if (body.include) {
            formData.append('include', JSON.stringify(body.include))
          }
          if (body.choices) {
            formData.append('choices', JSON.stringify(body.choices))
          }

          return formData
        },
      }),
    )
  },

  async delete(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/medical-document-template/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async generatePreview(template: ApiSchemas['CreateMedicalDocumentTemplateDto']) {
    return wrapEndpoint(() =>
      client.POST('/medical-document-template/preview', {
        body: template,
        parseAs: 'blob',
        bodySerializer(body) {
          const formData = new FormData()
          formData.append('type', body.type)
          formData.append('physicianId', body.physicianId.toString())
          if (body.clinicLogo) {
            formData.append('clinicLogo', body.clinicLogo)
          }
          formData.append('include', JSON.stringify(body.include))
          if (body.choices) {
            formData.append('choices', JSON.stringify(body.choices))
          }

          return formData
        },
      }),
    )
  },

  async generatePreviewFromExisting(id: number) {
    return wrapEndpoint(() =>
      client.PATCH('/medical-document-template/{id}/preview', {
        params: {
          path: {
            id,
          },
        },
        parseAs: 'blob',
      }),
    )
  },
}
